import React from 'react';
import PropTypes from 'prop-types';
import Heading from '@cotyorg/ccx-atoms/Heading/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import R from 'ramda';
import SectionHeader from '../../../atoms/SectionHeader';

export const InvolvedSection = ({ sectionHeading }) => (
  <div className="article-section article-section--padding-bottom">
    <div className="grid-container">
      <div className="grid-x grid-margin-x">
        <div className="cell">
          <SectionHeader>
            <Heading level={2}>{R.prop('heading', sectionHeading)}</Heading>
          </SectionHeader>
          <SectionHeader>
            <Heading level={3}>{R.prop('subheading', sectionHeading)}</Heading>
          </SectionHeader>
          <Paragraph>{R.prop('introduction', sectionHeading)}</Paragraph>
        </div>
      </div>
    </div>
  </div>
);

InvolvedSection.propTypes = {
  sectionHeading: PropTypes.instanceOf(PropTypes.object),
};
